<template>
  <ui-card>
    <ui-title class="has-text-white mb-4">
      {{ $t('dashboard_questions.title') }}
    </ui-title>

    <ui-tabs v-model="activeTab" :tabs="tabs" />

    <ui-tab>
      <ui-table
        :key="$i18n.locale"
        ref="dataTable"
        service="roundHistoryQuestion"
        method="getRoundHistoryQuestions"
        rowHoverEffect
        :headers="headers"
        :queryParams="getQueryParams"
        :activeTab="activeTab"
        @rowClick="e => $emit('rowClick', e)"
      ></ui-table>
    </ui-tab>
  </ui-card>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'DashboardQuestionsTable',

  props: {
    customerId: {
      type: String,
      default: ''
    }
  },

  data: () => ({
    activeTab: 'toHandle'
  }),

  computed: {
    ...mapGetters('user', ['getActiveCustomer', 'getActiveBuilding']),

    headers() {
      return [
        { text: this.$t('dashboard_questions.header.item'),  value: 'name',              sortable: true },
        { text: this.$t('dashboard_questions.header.flaw'),  value: 'answerDescription', sortable: true },
        { text: this.$t('dashboard_questions.header.found'), value: 'created',           sortable: true,
          transform: val => this.$utils.date.getFullDate(val) },
        { text: this.$t('dashboard_questions.header.round'), value: 'roundPlanningName', sortable: true }
      ];
    },

    tabs() {
      return [
        { key: 'toHandle', label: this.$t('dashboard_questions.tabs.toHandle'), icon: 'fa-sticky-note' },
        { key: 'done',     label: this.$t('dashboard_questions.tabs.done'),     icon: 'fa-check' },
        { key: 'all',      label: this.$t('dashboard_questions.tabs.all'),      icon: 'fa-align-left' }
      ];
    },

    getQueryParams() {
      const filter = {};
      if (this.activeTab === 'toHandle') {
        filter.done = false;
        filter.response = false;
      }
      if (this.activeTab === 'done') {
        filter.done = true;
      }
      return {
        customerId: this.customerId,
        buildingId: this.getActiveBuilding.id,
        ...filter
      };
    }
  },

  watch: {
    '$i18n.locale'() {
      this.$nextTick(() => {
        this.$refs.dataTable && this.$refs.dataTable.fetchData && this.$refs.dataTable.fetchData();
      });
    }
  },

  methods: {
    fetchData() {
      this.$refs.dataTable && this.$refs.dataTable.fetchData && this.$refs.dataTable.fetchData();
    }
  }
};
</script>
